/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabriele
 * File: ExportErrorsCallout.tsx
 * Project: mle-client-n
 * Committed last: 2022/6/14 @ 1043
 * ---
 * Description:
 */

import { Callout, Intent }    from '@blueprintjs/core';
import { MarkerSignalButton } from '../button/MarkerSignalButton';

interface Props {
  className?: string;
}

export const ExportErrorsCallout = (props: Props) => {
  return (
    <Callout title="Impossibile esportare" intent={ Intent.DANGER }
             className={ props.className }>
      <div className="flex flex-row">
        <div className="bp4-text-muted">
          Si sono verificati errori durante l'esportazione. Per maggiori
          dettagli
          contatta il supporto.
        </div>
        <div>
          <MarkerSignalButton text="Segnala"/>
        </div>
      </div>
    </Callout>
  );
};